export const environment = {
  production: true,
  posthogKey: 'phc_wJufDvhSEV2Nw6A577kTpdu58zTJGSKwAfQgAKA9bQ9j',
  posthogHost: 'https://us.i.posthog.com',
  apiBaseUrl: 'https://api.slicksell.com.br',
  serverUrlHostSwoole: 'https://krabo.online:8089/api',
  paymentGenetatorLinkURL: 'https://api.slicksell.com.br/api',
  serverUrl: 'https://api.slicksell.com.br/api',
  frontendUrl: 'https://slicksell.link',
  usetifulToken: '84930dcea928318af9a86b5498f4f3a5',
  isWidgetBuild: false,
  // Ver comentário em environment.ts — nunca deve ser true em produção.
  forceTokenAuth: false,
  stripePublishableKey: 'pk_live_51Sp7W49t1HkshAuwJG0WhJLla1DBuUrBTSnvYx4kelSSv8uB2TEBVOY1ZvwOEWyMl21yX2Mnbif0MmyGp93ciRHZ00Ua3u8sYU',
  appBaseUrl: 'https://app.slicksell.com.br',
  shopifyClientId: '0d45482ed6adf4a59e4e8fc7f367b9ab',
  nuvemshopAppId: '21877',
};
